export default {
  state: {
    website_name: ''
  },
  mutations: {
    updateWebsiteName(state, newValue) {
      state.website_name = newValue;
    }
  },
  actions: {
    setWebsiteName({ commit }, newValue) {
      commit('updateWebsiteName', newValue);
    }
  },
  getters: {
    getWebsiteName: state => state.website_name
  }
};
